import { useRequiredContext } from "@lib/utils";

import { PanelStack } from "../../shared/PanelStack/PanelStack";
import { HaNContext } from "../../shell/HaNContext";
import { HaNDetailsContext } from "../../shell/regions/HaNDetailsContext";
import { FacilityInfoPage } from "./FacilityInfoPage";

export const FacilityDetails = () => {
  const { selection } = useRequiredContext(HaNDetailsContext);

  if (selection.kind !== "facility") return null;

  return <FacilityDetailsContent facilityId={selection.id} />;
};

type FacilityDetailsContentProps = {
  facilityId: string;
};

// Looks the facility up among all of the building's facilities, so opening another category doesn't close its details
const FacilityDetailsContent = ({ facilityId }: FacilityDetailsContentProps) => {
  const { facilities } = useRequiredContext(HaNContext);
  const facility = facilities.find(f => f.id === facilityId);

  if (!facility) return null;

  return (
    <PanelStack initial="info">
      <PanelStack.Page pageId="info">
        <FacilityInfoPage facility={facility} />
      </PanelStack.Page>
    </PanelStack>
  );
};
